import { SectionBrowser, PageHeader } from 'global/LandingPage';
import { ASSET_URL } from '../constants';
import { chartbitContents, additionalInfos } from './content';
import { AdditionalWrapper, Title, Description } from '../styled';

function Chartbit() {
  return (
    <>
      <PageHeader
        title="Chartbit"
        description="Charting tools modern dan canggih dengan ratusan indikator untuk menganalisa dan memprediksi harga saham"
      />
      {chartbitContents.map((content, index) => (
        <SectionBrowser
          title={content.title}
          image={`${ASSET_URL}${content.image}`}
          description={content.description}
          reverse={index % 2 === 0}
        />
      ))}
      <AdditionalWrapper>
        {additionalInfos.map((info) => (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Title>{info.title}</Title>
            <Description>{info.description}</Description>
          </div>
        ))}
      </AdditionalWrapper>
    </>
  );
}

export default Chartbit;
